/**
 * Contract-backed API invocation (design 5.3.1).
 *
 * Feature clients call worker endpoints ONLY through their shared route
 * contracts — path and parameter construction exist once, in the contract.
 * Raw '/api/…' literals in frontend code are a lint error.
 */

import apiClient from './services/apiClient'

export function callContract(contract, { params, query, body, config } = {}) {
  const url = contract.build(params, query)
  switch (contract.method) {
    case 'GET':
      return apiClient.get(url, config)
    case 'DELETE':
      return apiClient.delete(url, config)
    case 'POST':
      return apiClient.post(url, body, config)
    case 'PUT':
      return apiClient.put(url, body, config)
    case 'PATCH':
      return apiClient.patch(url, body, config)
    default:
      throw new Error(`unsupported contract method: ${contract.method}`)
  }
}
